import * as _ from 'lodash';
import collectionUtils from '../../../common/collection-utils';
import {GEO_TYPES} from '../../../../serp/constants';

angular.module('cian.metroBrowser').controller('MetroBrowserCtrl', [
  '$scope',
  '$uibModalInstance',
  '$document',
  'ApiService',
  'AnalyticsService',
  'FilterService',
  'FilterTermsService',
  'MetroService',
  'ScrollService',
  'RegionIds',
  'regionId',
  'geo',
  'footMin',
  'onlyFoot',
  /**
   * @param {number} regionId - id региона, для которого показываем карту метро
   * @param {FilterItem} geo - гео-фильтр
   * @param {FilterItem} footMin - время до метро
   * @param {FilterItem} onlyFoot - способ до метро
   */
    function ($scope,
              $uibModalInstance,
              $document,
              ApiService,
              AnalyticsService,
              FilterService,
              FilterTermsService,
              MetroService,
              ScrollService,
              RegionIds,
              regionId,
              geo,
              footMin,
              onlyFoot) {
    this.onlyFoot = onlyFoot;
    this.footMin = footMin;
    this.terms = FilterTermsService;

    let selectedStations = _.filter(geo.value, {type: GEO_TYPES.UNDERGROUND});

    const setStations = stations => {
      selectedStations = stations;
      collectionUtils.updateSubsetOfCollectionInPlace(
        geo.value,
        selectedStations,
        [GEO_TYPES.UNDERGROUND]
      );
    };

    // Прокручиваем карту на середину
    $uibModalInstance.rendered.then(() => {
      const metroBrowserElement = $document[0].querySelector('.metro-browser');
      // Пользователь может очень быстро закрыть попап
      // и в таком случае metroBrowserElement будет null
      if (metroBrowserElement) {
        ScrollService.scrollInParentsCenter(metroBrowserElement);
      }
    });

    this.defaultOnlyFootValue = MetroService.FOOT_MIN_DEFAULT;

    // Показать кнопки только в Москве, потому что только в Москве есть кольцо
    this.showAdvancedButtons = () => regionId === RegionIds.REGIONS.MOSCOW;

    const selectStation = station => {
      setStations(selectedStations.concat(station));
      // Устанавливаем путь до метро по умолчанию (только для аренды)
      if (FilterService.dealTypeIs('rent')) {
        MetroService.updateFootValuesOnStationSelection(
          this.onlyFoot, this.footMin
        );
      }
    };

    const deselectStation = station =>
      setStations(_.reject(selectedStations, {id: station.id}));

    this.toggleStation = station => {
      if (this.isInSelected(station.id)) {
        deselectStation(station);
      } else {
        selectStation(station);
      }
    };

    this.deselectAll = () => {
      setStations([]);
      this.isInsideCircleToggled = false;
      this.isCircleToggled = false;
    };

    // #FIXME: Эта функция выполняется при выборе станции для каждой станции на схеме метро. Очень тормозит отрисовку
    this.isInSelected = id => selectedStations.some(item => item.id === id);

    this.getSelectedLength = () => selectedStations.length;

    const toggleStations = (condition, stationsToToggle) => {
      if (condition) {
        setStations(_.uniqBy(
          selectedStations.concat(
            this.scheme.stations.filter(station => stationsToToggle.includes(station.id))
          ),
          'id'
        ));
      } else {
        setStations(
          selectedStations.filter(station => !stationsToToggle.includes(station.id))
        );
      }
    };

    this.toggleCircle = () => toggleStations(!this.isCircleToggled, this.scheme.circleNewIds);

    this.toggleInsideCircle = () => toggleStations(!this.isInsideCircleToggled, this.scheme.insideNewIds);

    this.imageMap = (() => {
      if (regionId === RegionIds.REGIONS.MOSCOW) {
        return {
          'class': 'als_metro_moscow',
          branchesName: 'als_metro_branches_moscow'
        };
      } else if (regionId === RegionIds.REGIONS.SPB) {
        return {
          'class': 'als_metro_spb',
          branchesName: 'als_metro_branches_spb'
        };
      }
    })();

    this.save = () => {
      AnalyticsService.trackCA('Listing', 'popup_metro_save', String(selectedStations.length), {});
      $uibModalInstance.close();
    };

    this.isLoading = true;
    ApiService.getScheme(regionId).then(response => {
      const data = response.data;
      this.scheme = {
        stations: data.stations.map(item => ({
          type: GEO_TYPES.UNDERGROUND,
          id: item.new_id,
          text: item.name,
          color: item.color,
          labels: item.labels
        })),
        insideNewIds: data.inside_new_ids,
        circleNewIds: data.circle_new_ids
      };
      this.uniqueIds = this.scheme.stations.reduce((memo, station) => {
        return memo.set(station, `${station.id}-${station.color}`);
      }, new WeakMap());

      if (regionId === RegionIds.REGIONS.MOSCOW) {
        const allIdsSelected = stationsIds => stationsIds.every(stationId => selectedStations.some(station => station.id === stationId));
        this.isCircleToggled = allIdsSelected(this.scheme.circleNewIds);
        this.isInsideCircleToggled = allIdsSelected(this.scheme.insideNewIds);
      }
    }).finally(() => this.isLoading = false);
  }]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-browser.ctrl.js